export default __webpack_public_path__ + "static/media/cyp.3d0cdba5.png";